import Location from './Location';

export default class Court extends Location {

	constructor (master) {

		super(master, "court");
	}
}